import React from 'react';
import styled from '@emotion/styled';

import Stacheldraht from '../Stacheldraht';
import ExternalLinksCollection, { ExternalLinksShape } from '../ExternalLinksCollection';

import { showOnlyOnDesktop } from '../styles/breakpoints';

const Container = styled.section`
  margin-bottom: 60px;
  padding-top: 10px;
`;

const StacheldrahtStyled = styled(Stacheldraht)`
  ${showOnlyOnDesktop};
`;

const ProofOfSources = ({ sources }) => (
  <Container>
    <ExternalLinksCollection headline="Lehreinheiten und weitere Informationen" sources={sources} showIds collapsable />
    <StacheldrahtStyled small />
  </Container>
);

ProofOfSources.propTypes = {
  sources: ExternalLinksShape.isRequired,
};

export default ProofOfSources;



// WEBPACK FOOTER //
// ./src/components/ProofOfSources/ProofOfSources.js